export const GET_LOGIN_JWT = 'GET_LOGIN_JWT';

/**
 * Get login jwt.
 * @function getLoginJwt
 * @returns {Object} Get login jwt results action.
 */
export function getLoginJwt() {
  return {
    type: GET_LOGIN_JWT,
    request: {
      op: 'post',
      path: `/@session-login`,
    },
  };
}
